export default {
  buttons: {
    change_plan: 'Schimbă planul',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
    failed_to_save_changes: 'Eroare la salvarea modificărilor',
  },
};
